import Table from "../../../../../../common/components/molecule/Table/Table";
import { limitString } from "../../../../../../utils/string.utils";
import { HardwaresType } from "../../../../types/hardware.types";

export interface HardwareListViewProps {
  content: HardwareItem[];
  nbFound?: number;
}

export interface HardwareItem {
  id: string;
  onClick?: () => void;
  devuid?: string;
  hardwareType?: HardwaresType;
  ActionBtnRender?: () => JSX.Element;
  AssociatedElement?: () => JSX.Element;
  secretKey?: string;
  secretKeyAvoir?: string;

}
export default function HardwareListView({ content, nbFound }: HardwareListViewProps) {
  return (
    <>
      <Table
        emptyMessage="Aucun hardware trouvé"
        headerTitle={["Device ID", "Hardware Type", "Associé à","Clé secrète","Clé secrète avoir "]}
        bodyData={
          content.map((item) => ({
            id: item.id,

            data: [
              item.devuid,
              item.hardwareType,
              item.AssociatedElement,
              limitString(item.secretKey || "", 2, "***"),
              limitString(item.secretKeyAvoir || "", 2, "***"),
              item.ActionBtnRender,
            ],
          })) || []
        }

        NbFoundViewProps={{
          nbFound: nbFound,
          itemName: { single: "hardware trouvé", plurial: "hardwares trouvés" },
        }}
      />
    </>
  );
}
